
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iUxNS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $987c3535facb794a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $5112f71c1fe48fdd$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': "\u5F59\u7E3D\u8CC7\u6599",
    'extension.charts.aggregateDataDescription': "\u7576\u591A\u500B\u5217\u5177\u6709\u76F8\u540C\u7684\u503C\u6642\uFF0C\u5C07\u503C\u7D44\u5408\u70BA\u55AE\u4E00\u8CC7\u6599\u9EDE\u3002",
    'extension.charts.category': "\u985E\u5225",
    'extension.charts.customizeTab': "\u81EA\u8A02",
    'extension.charts.dataMissing.details': "\u6211\u5011\u5728\u9801\u9762\u4E0A\u627E\u4E0D\u5230\u6B64\u5716\u8868\u7684\u4F86\u6E90\u8868\u683C\u3002",
    'extension.charts.dataMissing.title': "\u6C92\u6709\u53EF\u986F\u793A\u7684\u8CC7\u6599",
    'extension.charts.dataTab': "\u8CC7\u6599",
    'extension.charts.defaultColumnName': "\u6B04 {0}",
    'extension.charts.defaultTitle': "\u672A\u547D\u540D\u5716\u8868",
    'extension.charts.defaultYLabel': "\u672A\u547D\u540D\u7684\u8EF8",
    'extension.charts.extensionTitle': "\u5716\u8868",
    'extension.charts.height': "\u7E6A\u88FD\u5340\u57DF\u9AD8\u5EA6",
    'extension.charts.height.large': "\u8F03\u9AD8",
    'extension.charts.height.medium': "\u9810\u8A2D",
    'extension.charts.height.small': "\u8F03\u77ED",
    'extension.charts.horizontal.orientation.label': "\u6C34\u5E73",
    'extension.charts.insert.tooltip': "\u63D2\u5165\u5716\u8868",
    'extension.charts.legend': "\u5716\u4F8B",
    'extension.charts.legend.auto': "\u81EA\u52D5",
    'extension.charts.legend.bottom': "\u5E95\u90E8",
    'extension.charts.legend.left': "\u5DE6\u5074",
    'extension.charts.legend.position': "\u5716\u4F8B\u4F4D\u7F6E",
    'extension.charts.legend.right': "\u53F3\u5074",
    'extension.charts.legend.show': "\u986F\u793A\u5716\u4F8B",
    'extension.charts.legend.top': "\u9802\u7AEF",
    'extension.charts.options.label': "\u5716\u8868\u9078\u9805",
    'extension.charts.options.tooltip': "\u8B8A\u66F4\u5716\u8868\u9078\u9805",
    'extension.charts.orientation.label': "\u65B9\u5411",
    'extension.charts.seriesNames': "\u8CC7\u6599\u7CFB\u5217",
    'extension.charts.showPoints': "\u986F\u793A\u8CC7\u6599\u9EDE",
    'extension.charts.smoothLines': "\u5E73\u6ED1\u7DDA\u689D",
    'extension.charts.style': "\u6A23\u5F0F",
    'extension.charts.title': "\u6A19\u984C",
    'extension.charts.type.bar': "\u5217",
    'extension.charts.type.fieldDescription': "\u5716\u8868\u985E\u578B",
    'extension.charts.type.line': "\u7DDA\u689D",
    'extension.charts.type.pie': "\u5713\u9905",
    'extension.charts.userTitle': "\u6A19\u984C",
    'extension.charts.vertical.orientation.label': "\u5782\u76F4",
    'extension.charts.xAxis': "X \u8EF8",
    'extension.charts.xLabel': "X \u8EF8\u6A19\u7C64",
    'extension.charts.yLabel': "Y \u8EF8\u6A19\u7C64"
};


var $987c3535facb794a$export$2e2bcd8739ae039 = (0, $5112f71c1fe48fdd$export$2e2bcd8739ae039);

});


//# sourceMappingURL=zh_TW.74c75f5f.js.map
